import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useAuthStore } from './lib/auth'
import ProtectedRoute from './components/ProtectedRoute'
import ErrorBoundary from './components/ErrorBoundary'
import AdminRoute from './components/AdminRoute'
import ScrollToTop from './components/ScrollToTop'
import { usePageView } from './hooks/useAnalytics'
import Landing from './pages/Landing'
import Dashboard from './pages/Dashboard'
import About from './pages/About'
import Plans from './pages/Plans'
import HowTo from './pages/HowTo'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import Settings from './pages/Settings'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Terms from './pages/Terms'
import FAQ from './pages/FAQ'
import Disclaimer from './pages/Disclaimer'
import Security from './pages/Security'
import Report from './pages/Report'
import AdminDashboard from './pages/AdminDashboard'
import FreeScan from './pages/FreeScan'
import AuthCallback from './pages/AuthCallback'

import { AnimatePresence } from 'framer-motion'
import { useLocation, useNavigate } from 'react-router-dom'
import PageTransition from './components/PageTransition'
import SessionExpiredToast from './components/SessionExpiredToast'
import ScamViewChat from './components/ScamViewChat'

function AppRoutes() {
  const initialize = useAuthStore((s) => s.initialize)
  const location = useLocation()
  const navigate = useNavigate()
  usePageView()

  useEffect(() => {
    initialize()
    if (window.location.hash.includes('type=recovery')) {
      navigate('/reset-password' + window.location.hash, { replace: true })
    }
  }, [initialize, navigate])

  return (
    <>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* Main Pages */}
          <Route path="/" element={<PageTransition><Landing /></PageTransition>} />
          <Route path="/about" element={<PageTransition><About /></PageTransition>} />
          <Route path="/plans" element={<PageTransition><Plans /></PageTransition>} />
          <Route path="/how-to" element={<PageTransition><HowTo /></PageTransition>} />
          <Route path="/free-scan" element={<PageTransition><FreeScan /></PageTransition>} />

          {/* Authentication */}
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/login" element={<PageTransition><Login /></PageTransition>} />
          <Route path="/register" element={<PageTransition><Register /></PageTransition>} />
          <Route path="/forgot-password" element={<PageTransition><ForgotPassword /></PageTransition>} />
          <Route path="/reset-password" element={<PageTransition><ResetPassword /></PageTransition>} />
          <Route path="/verify-email" element={<PageTransition><VerifyEmail /></PageTransition>} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<PageTransition><ProtectedRoute><Dashboard /></ProtectedRoute></PageTransition>} />
          <Route path="/settings" element={<PageTransition><ProtectedRoute><Settings /></ProtectedRoute></PageTransition>} />
          <Route path="/report" element={<PageTransition><ProtectedRoute><Report /></ProtectedRoute></PageTransition>} />
          <Route path="/admin" element={<PageTransition><AdminRoute><AdminDashboard /></AdminRoute></PageTransition>} />

          {/* Legal & Info */}
          <Route path="/privacy" element={<PageTransition><PrivacyPolicy /></PageTransition>} />
          <Route path="/terms" element={<PageTransition><Terms /></PageTransition>} />
          <Route path="/faq" element={<PageTransition><FAQ /></PageTransition>} />
          <Route path="/disclaimer" element={<PageTransition><Disclaimer /></PageTransition>} />
          <Route path="/security" element={<PageTransition><Security /></PageTransition>} />
        </Routes>
      </AnimatePresence>
    </>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRoutes />
        <SessionExpiredToast />
        <ScamViewChat />
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
